import React from 'react';

export default function StepMatrix({ matrix, onBack, onNext, loading }) {
  // matrix: [{ keyword, service, location }]
  // Only location keywords (no nationals) per user requirement

  const byService = matrix.reduce((acc, k) => {
    if (!acc[k.service]) acc[k.service] = [];
    acc[k.service].push(k);
    return acc;
  }, {});

  const locations = [...new Set(matrix.map(k => k.location))];

  return (
    <div>
      <div className="page-header">
        <div className="page-title">Keyword matrix</div>
        <div className="page-sub">
          All approved keywords combined with each location. These will be sent to DataForSEO for volume and ranking data.
        </div>
      </div>

      <div className="metric-grid">
        <div className="metric-card">
          <div className="metric-label">Total keywords</div>
          <div className="metric-value">{matrix.length.toLocaleString()}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Services</div>
          <div className="metric-value">{Object.keys(byService).length}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Locations</div>
          <div className="metric-value">{locations.length}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Est. API credits</div>
          <div className="metric-value">{matrix.length.toLocaleString()}</div>
        </div>
      </div>

      <div className="alert alert-info">
        All keywords below include a location — no generic national keywords are included, keeping API usage efficient.
      </div>

      {Object.entries(byService).map(([service, keywords]) => (
        <div className="card" key={service} style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
            <div className="card-title" style={{ marginBottom: 0 }}>{service}</div>
            <span style={{ fontSize: 12, color: 'var(--gray-500)' }}>{keywords.length} keywords</span>
          </div>
          <div style={{ maxHeight: 200, overflowY: 'auto' }}>
            <table className="kw-table">
              <thead>
                <tr>
                  <th>Keyword</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                {keywords.slice(0, 30).map((k, i) => (
                  <tr key={i}>
                    <td>{k.keyword}</td>
                    <td>{k.location}</td>
                  </tr>
                ))}
                {keywords.length > 30 && (
                  <tr>
                    <td colSpan={2} style={{ color: 'var(--gray-500)', fontStyle: 'italic' }}>
                      … and {keywords.length - 30} more
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      ))}

      <div className="actions">
        <button className="btn" onClick={onBack}>← Back</button>
        <button className="btn btn-primary" onClick={onNext} disabled={loading || matrix.length === 0}>
          {loading
            ? <><span className="spinner" /> Fetching data…</>
            : `Fetch volumes + rankings (${matrix.length} keywords) →`}
        </button>
      </div>
    </div>
  );
}
